import styles from './styles.module.css';
import React, { Component } from 'react';

const MinAMinDoble = (props) =>  {
    
    const {
        isPreview,
        url_iframe,
        url_iframe2
    } = props;
    
  return (



  <div className={isPreview ? styles['preview-container-minamindoble'] : styles['container-minamindoble']}> 

  <div  className={styles['box1']}>
  <a href="https://www.ellitoral.com/um/tetengue"  className={styles['tatengue']}><span className={styles['circle-union']}></span> Tatengue</a>  
  <iframe
                        src={url_iframe}
                        height="118"
                        frameborder="0"
                        allowfullscreen
                        scrolling="no"
                        sandbox>
                    </iframe>
  </div>
 
  <div  className={styles['box2']}>
<div className={styles['contenedor-btn']}>
      <div className={styles['botones-accesos']}></div>
</div>      
      <div className='ad-slot' id='mam' data-adtype='sponsor_fijo'> </div>
    </div>
  
  <div  className={styles['box3']}>
  <a href="https://www.ellitoral.com/um/sabalera"  className={styles['sabalera']}><span className={styles['circle-colon']}></span> Sabalera</a>  
  <iframe
                        src={url_iframe2}
                        height="118"
                        frameborder="0"
                        allowfullscreen
                        scrolling="no"
                        sandbox>
                    </iframe>
</div>

</div>
    )
}
export default MinAMinDoble;
